module.exports = __webpack_public_path__ + "media/notosans/SubNotoSansJP_regular-413e6181.woff2";